const $ = require('jquery');
import run from '../../utilities/run';
import {bindJumpToWizardLinks} from '../../utilities/jumpToWizardLogic';
const targetSelector = "#orderType-detail-page";
import {shallAllowClick} from "../../utilities/general";


run(targetSelector,(mainEl) => {
    const updateOrderTypeStatusUrl = mainEl.data("updateOrderTypeStatusUrl");
    const orderTypeDetailsUrl = mainEl.data("orderTypeDetailsUrl");
    const duplicaterOrderTypeUrl = mainEl.data("duplicate-ordertype-url");

    bindJumpToWizardLinks();  

    $("body").on("click", "#duplicate-btn", function (e) {
        window.location.href = duplicaterOrderTypeUrl + "&isDup=true";
    });

    $('body').on('click', '#activate-deactivate-btn', function(e) {
		
        e.preventDefault();
        if (shallAllowClick(this)) {
            var submitModalFlow = null;
            var orderTypeStatus = $(this).data('orderTypeStatus');
            if (orderTypeStatus == 'active') {
                submitModalFlow = new SubmitModalFlow({
                    confirmModalTitle: 'Deactivate Order Type',
                    confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this order type will no longer be available when creating orders. It can be activated at any time.</div>',
                    confirmModalBtnText: 'Deactivate',
                    onConfirmClick: function () {
                        submitModalFlow.showLoadingModal();
                        updateOrderTypeStatus(submitModalFlow);
                    }
                });
            } else {
                submitModalFlow = new SubmitModalFlow({
                    confirmModalTitle: 'Activate Order Type',
                    confirmModalBody: '<div class="q-pad-all-xl">Once activated, this order type will continue to be available when creating orders. It can be deactivated at any time.</div>',
                    confirmModalBtnText: 'Activate',
                    onConfirmClick: function () {
                        submitModalFlow.showLoadingModal();
                        updateOrderTypeStatus(submitModalFlow);
                    }
                });
            }
            submitModalFlow.init();
            submitModalFlow.showConfirmModal();
        }
    });

	function updateOrderTypeStatus(submitModalFlow){
		$.ajax({
            url: updateOrderTypeStatusUrl,
            type: 'POST',
            dataType: 'JSON',
            data: {},
            success: function(data) {
                if (data.responseStatus === "success") {
                    
                    submitModalFlow.showSuccessModal();
                    setTimeout(function() {
                        submitModalFlow.hideAllModals();
                        location.href = orderTypeDetailsUrl;
                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
                } else {
                    submitModalFlow.showFailureModal();
                }
            },
            error: function(data) {
                submitModalFlow.hideAllModals();
            }
        });
	}
});


// WEBPACK FOOTER //
// ./src/pages/orderType/details.js